import * as tslib_1 from "tslib";
import { FieldType } from '@ngx-formly/core';
var FormlyFieldTextContent = /** @class */ (function (_super) {
    tslib_1.__extends(FormlyFieldTextContent, _super);
    function FormlyFieldTextContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyFieldTextContent;
}(FieldType));
export { FormlyFieldTextContent };
